import React from "react";
export const PurpleThing4 = () => (
  <svg className="purple-thing4" version="1.2" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    <path d="m8.35 4.33a3.96 3.96 0 0 1-3.96 3.96 3.96 3.96 0 0 1-3.96-3.96 3.96 3.96 0 0 1 3.96-3.96 3.96 3.96 0 0 1 3.96 3.96zm-5.05-0.55q-0.34 0.72 0.45 0.65 1.73-0.15 2.15-1.64a0.56 0.53-74.7 0 0-0.37-0.68q-1.3-0.34-2.23 1.67z" fill="var(--contrast-lighter)"/>
    <path d="m3.3 3.78q0.93-2.01 2.23-1.67a0.56 0.53-74.7 0 1 0.37 0.68q-0.42 1.49-2.15 1.64-0.79 0.07-0.45-0.65z" fill="var(--light)"/>
  </svg>
);

export default PurpleThing4;